import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from "react-intl";
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  WeekView,
  Appointments,
} from '@devexpress/dx-react-scheduler-material-ui';
import moment from 'moment';
import { getAppointmentsListRequest } from '../../store/appointments/actions';
import Tooltip from '@material-ui/core/Tooltip';

    // APPOINTMENT STYLE

const Appointment = ({ style, children, data, ...restProps}) => {
    let color = '#E1EDFF';
    if (data.type === 1) {
        color = "#FCE4D3";
    } else if (data.type === 2) {
        color = "#E8FBFB";
    } else if (data.type === 3) {
        color = "#E1EDFF";
    }

    return (<Appointments.Appointment
    {...restProps}
    style={{
        ...style,
        pointerEvents: 'all',
        backgroundColor: `${color}`,
        borderRadius: '0px',
        boxShadow: '0px 0px 2px #00000029',
        width: '108%',
        padding: '2px 0',
    }}
    >
    {children}
    </Appointments.Appointment>)
};

// APPOINTMENT CONTENT -

const AppointmentContent = ({ style, data, ...restProps }) => {
    return (
    <Appointments.AppointmentContent {...restProps} data={data} >
        <div style={{ padding: '0', color: '#222', fontSize: '9px', fontWeight: 'bold', width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <Tooltip title={data.title} placement="bottom" style={{ cursor: "help" }}>
                <span className="app_title">
                    {data.title.length > 8 ? `${data.title.substring(0,7)}..` : data.title}
                </span>
            </Tooltip>
            <span style={{ fontSize: '8px', textAlign: 'right' }}>{ moment(data.startDate).format('h:mm A')}</span>
        </div>
    </Appointments.AppointmentContent>
)};


const Schedule = ({ intl: { messages }, currentDate, userId }) => {
    const dispatch = useDispatch();
    const lang = localStorage.getItem("lang") || "en";
    const { appointmentsList } = useSelector((state) => state.appointments);

    useEffect(() => {
        if (userId && currentDate) { 
            dispatch(getAppointmentsListRequest({
                user_id: userId,
                start_date: moment(currentDate, 'YYYY-MM-DD').subtract(5, 'days').format('YYYY-MM-DD'),
                end_date: moment(currentDate, 'YYYY-MM-DD').add(5, 'days').format('YYYY-MM-DD')
            })); 
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentDate, userId]);
    
    return (<Scheduler
        data={appointmentsList?.appointments}
        height={680}
        defaultCurrentView="week"
        locale={lang === 'ar' ? 'ar' : 'en'}
    >
        <ViewState
            currentDate={currentDate}
        />
        <WeekView
            startDayHour={7}
            endDayHour={21}
            excludedDays={appointmentsList?.holiydays || [5, 6]}
            cellDuration={60}
        />
        <Appointments 
            appointmentComponent={Appointment}
            appointmentContentComponent={AppointmentContent}
            />
    </Scheduler>)
};

export default injectIntl(Schedule)